import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Row, Col, DatePicker, Button } from 'antd';
import { makeStyles } from '@material-ui/styles';
import { dayFormatType, formatDay, moment } from 'common/helpers/day';

const useStyles = makeStyles(theme => ({
  wrapper: {
    width: 240,
    background: '#fff',
  },
  main: {
    padding: '12px',
  },
  input: {
    '& input': {
      width: 214,
      paddingLeft: 8,
      fontSize: 14,
      paddingRight: '8px !important',

      '&::placeholder': {
        fontSize: 14,
      },
    },
  },
  footer: {
    padding: '10px 12px 13px',
    textAlign: 'right',
    borderTop: '1px solid #e8e8e8',
  },
  resetBtn: ({ value }) => ({
    display: 'inline-block',
    width: 49,
    height: 24,
    lineHeight: '24px',
    textAlign: 'center',
    marginRight: 12,
    fontSize: 12,
    cursor: value ? 'pointer' : 'not-allowed',
    color: value ? theme.colors.bodyColor : theme.colors.disableColor,
    boxShadow: 'none',
    borderRadius: 2,

    '&:hover': {
      backgroundColor: value ? '#f5f5f5' : 'transparent',
    },
  }),
  searchBtn: {
    fontSize: 12,
    paddingLeft: 8,
    paddingRight: 8,
    boxShadow: 'none',
  },
}));

const dateFormat = dayFormatType.FILTERPARAMS;
const SearchDateComponent = ({ field, value: initialValue, onChange, disabledDate }) => {
  const { t } = useTranslation();

  const wrapperRef = useRef(null);

  const [value, setValue] = useState(
    initialValue.length ? [moment(initialValue[0]), moment(initialValue[1])] : [],
  );

  const classes = useStyles({ value: initialValue });

  const handleInputChange = dates => {
    setValue(dates);
  };

  const handleSearchClick = () => {
    const formatted = value.length
      ? [
          formatDay(dayFormatType.FILTERPARAMS, value[0]),
          formatDay(dayFormatType.FILTERPARAMS, value[1]),
        ]
      : [];
    onChange(field, formatted);
  };

  const handleResetClick = () => {
    // if (!initialValue) return;

    setValue([]);
    onChange(field, []);
  };

  return (
    <Row className={classes.wrapper} ref={wrapperRef}>
      <Col span={24} className={classes.main}>
        <DatePicker.RangePicker
          name="field"
          className="promotion-plan-editor-container__body__date-selector"
          format={dateFormat}
          disabledDate={disabledDate}
          value={value}
          onChange={dates => {
            handleInputChange(dates);
          }}
        />
      </Col>
      <Col span={24} className={classes.footer}>
        <span className={classes.resetBtn} onClick={handleResetClick}>
          {t('cms:cms.landlord_account.table.reset')}
        </span>
        <Button
          size="small"
          type="primary"
          className={classes.searchBtn}
          onClick={handleSearchClick}
        >
          {t('cms:cms.landlord_account.table.search')}
        </Button>
      </Col>
    </Row>
  );
};

SearchDateComponent.propTypes = {
  field: PropTypes.string.isRequired,
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  disabledDate: PropTypes.func,
};

SearchDateComponent.defaultProps = {
  value: [],
};

export default SearchDateComponent;
